export const DEFAULT_ROUTE = '/apps/games/list';
